import script from "./reject-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./reject-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__